// import React, {Component} from 'react';
import publicpb from '../../base/public.pb';
import profilepb from './index.pb';
import PbAjax from '../pbajax';

const pbajax = new PbAjax();

class Profile {
    constructor(vuid) {
        // debugger;
        this.promise = this.getData({
            vuid
        });
    }

    getData(data) {

        let self = this;
        let businessData = new profilepb.Profile.Get.Request(data);
        let defer = $.Deferred()

        let ua = window.navigator.userAgent;

        pbajax.do({
                service: 'service',
                api: '/profile/get',
                header: {
                    userToken: UpSDK.getUserToken(),
                    UserAgent: ua
                }
            },
            businessData,
            function(res) {

                let dataWrap = publicpb.Result.decode(res);
                let data;

                if (dataWrap.code == 1) {
                    data = profilepb.Profile.Get.Response.decode(dataWrap.data.value);
                    defer.resolve(data.profile);
                } else {
                    if (dataWrap.code == 8192) {
                        
                    }
                }
            },
            () => {
                defer.reject();
            },
            () => {
                defer.reject();
            }
        );

        return defer.promise();
    }
}

export default Profile;


// WEBPACK FOOTER //
// ./js/component/openjs/deps/profile/index.js